export const RetailAccessLoadingSkeleton = () => (
  <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm">
    <div className="p-6 space-y-6">
      <div className="pb-4 border-b border-gray-200 dark:border-gray-700">
        <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100">
          Retail Locations-Based Access Control
        </h3>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Define granular access to specific retail locations and resources
        </p>
      </div>

      <div className="space-y-6">
        {[...Array<undefined>(4)].map((_, i) => (
          <div key={i} className="space-y-3">
            <div className="h-6 w-32 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
            <div className="h-10 w-full bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
          </div>
        ))}
      </div>
    </div>
  </div>
)
